import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

function ProtectedRoutes({ children, allowedRoles = [] }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Get user from session storage
    const userData = sessionStorage.getItem('user');
    if (userData) {
      setUser(JSON.parse(userData));
    }
    setLoading(false);
  }, []);

  // Show loading state while checking authentication
  
  if (loading) {
    return <div>Loading...</div>;
  }

  // If not logged in, redirect to login
  if (!user) {
    return <Navigate to="/Login" replace />;
  }

  // If allowedRoles is empty array, allow any authenticated user
  // Otherwise, check if user role is in the allowedRoles array
  if (allowedRoles.length === 0 || allowedRoles.includes(user.role)) {
    return children;
  } else {
    // If user doesn't have the required role, redirect to home page
    return <Navigate to="/" replace />;
  }
}

export default ProtectedRoutes;